import { render, staticRenderFns } from "./member-card.vue?vue&type=template&id=98246734&scoped=true&"
import script from "./member-card.vue?vue&type=script&lang=js&"
export * from "./member-card.vue?vue&type=script&lang=js&"
import style0 from "./member-card.vue?vue&type=style&index=0&id=98246734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98246734",
  null
  
)

export default component.exports